var _defs, _path, _g, _rect, _path2, _g2, _rect2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcon3(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 113.89 113.89",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#0c1f81;}.cls-2{fill:#ff8f0b;}.cls-3{fill:#eaeced;}.cls-4,.cls-5,.cls-6{fill:none;}.cls-5,.cls-6{stroke:#fff;stroke-linecap:round;stroke-miterlimit:10;}.cls-5{stroke-width:4px;}.cls-6{stroke-width:5px;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_161",
    "data-name": "Path 161",
    className: "cls-1",
    d: "M56.94,0A56.95,56.95,0,1,1,0,56.94,56.94,56.94,0,0,1,56.94,0Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Path_152",
    "data-name": "Path 152"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M56.53,109.15A51.59,51.59,0,0,1,4.88,57.49,51.63,51.63,0,0,1,93.06,21a51.68,51.68,0,0,1-16.42,84.12A51.22,51.22,0,0,1,56.53,109.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M56.53,7.83A49.65,49.65,0,0,0,21.42,92.61,49.67,49.67,0,1,0,56.53,7.83m0-4A53.66,53.66,0,1,1,2.88,57.49,53.66,53.66,0,0,1,56.53,3.83Z"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_59",
    "data-name": "Rectangle 59",
    className: "cls-4",
    x: 32.02,
    y: 29.91,
    width: 48.82,
    height: 54.9
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_117",
    "data-name": "Path 117",
    className: "cls-1",
    d: "M65.29,74.42a17.73,17.73,0,0,1,0-35.45"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_345",
    "data-name": "Group 345"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_116",
    "data-name": "Path 116",
    className: "cls-5",
    d: "M78.78,74.64a25.91,25.91,0,1,1-2-36.59,25.17,25.17,0,0,1,2.89,3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_60",
    "data-name": "Rectangle 60",
    className: "cls-1",
    x: 47.56,
    y: 38.97,
    width: 17.72,
    height: 35.45
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_118",
    "data-name": "Path 118",
    className: "cls-6",
    d: "M46.43,42.07a23.22,23.22,0,0,0-4.87,15.35c.14,5.67,2.26,9.64,6,13.91"
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_61",
    "data-name": "Rectangle 61",
    className: "cls-4",
    x: 32.02,
    y: 29.91,
    width: 48.82,
    height: 54.9
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon3);
export default __webpack_public_path__ + "static/media/Icon3.dfedfc0f7e23f4f65733d3d30a6d774b.svg";
export { ForwardRef as ReactComponent };